export default {
  label: {
    fontSize: 3
  },
  textarea: {
    fontFamily: "body"
  }
};
